import React from 'react';

import { usePromoModel } from '../../../../../../contexts/PromoModelProvider';

export const NumProducts = () => {
  const { itemCount } = usePromoModel();

  return (
    <span className="u__default-link" type="button" data-testid="promo-num-products">
      ({itemCount > 50 ? '50+' : itemCount}&nbsp;item{itemCount > 1 ? 's' : ''})
    </span>
  );
};

NumProducts.displayName = 'NumProducts';
